function InvoiceHeader({ order }) {

  const formattedDate = order?.createdAt
    ? new Date(order.createdAt).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
      })
    : "—";

  return (

    <div style={styles.card}>

      <div style={styles.leftIcon}>
        📄
      </div>

      <div>

        <div style={styles.title}>
          Invoice
        </div>

        <div style={styles.meta}>
          Order #{order?.orderNumber || "—"}
        </div>

        <div style={styles.meta}>
          Order Date: {formattedDate}
        </div>

        <div style={styles.statusRow}>

          <div style={styles.statusBadge}>
            {order?.status || "pending"}
          </div>

        </div>

      </div>

    </div>

  );

}

export default InvoiceHeader;

const styles = {

  card:{
    display:"flex",
    alignItems:"center",
    gap:30,

    padding:30,
    borderRadius:22,

    background:"linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",

    border:"2px solid #ffffff",

    boxShadow:
    "0 0 30px rgba(120,170,255,0.18), \
     0 20px 50px rgba(0,0,0,0.10), \
     0 6px 18px rgba(0,0,0,0.06), \
     inset 0 1px 0 rgba(255,255,255,1)",

    fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui"
  },

  leftIcon:{
    fontSize:42,

    background:"linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",

    width:72,
    height:72,
    borderRadius:18,

    display:"flex",
    alignItems:"center",
    justifyContent:"center",

    border:"2px solid #ffffff",

    boxShadow:
    "0 10px 25px rgba(0,0,0,0.08), \
     inset 0 1px 0 rgba(255,255,255,1)"
  },

  title:{
    fontSize:32,
    fontWeight:600,
    color:"#1D1D1F"
  },

  meta:{
    fontSize:15,
    color:"#6E6E73",
    marginTop:4
  },

  statusRow:{
    marginTop:14
  },

  statusBadge:{
    display:"inline-flex",
    alignItems:"center",
    justifyContent:"center",

    padding:"8px 14px",

    borderRadius:999,

    background:"#EEF4FF",

    color:"#2D6CFF",

    fontSize:13,
    fontWeight:600,

    textTransform:"capitalize"
  }

};